import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { createEntitySlice, EntityState, getAllRequest, serializeAxiosError } from '../shared/reducers/reducer.utils';

const apiUrl = 'api/profase-workflow-instancias';

function extractErrorMessage(error: any, fallback: string): string {
    const data = error?.response?.data;
    return data?.detail ?? data?.message ?? data?.title ?? error?.message ?? fallback;
}

export const getEntities = createAsyncThunk(
    'workflowInstancia/fetch_entity_list',
    async (request: any) => {
        const params = getAllRequest(request);
        return axios.get<any[]>(`${apiUrl}?${params}&cacheBuster=${new Date().getTime()}`);
    },
    { serializeError: serializeAxiosError },
);

export const createEntity = createAsyncThunk(
    'workflowInstancia/create_entity',
    async (entity: any) => {
        return axios.post<any>(apiUrl, entity);
    },
    { serializeError: serializeAxiosError },
);

export const deleteEntity = createAsyncThunk(
    'workflowInstancia/delete_entity',
    async (id: string | number) => {
        return axios.delete(`${apiUrl}/${id}`);
    },
    { serializeError: serializeAxiosError },
);

export const WorkflowInstanciaSlice = createEntitySlice({
    name: 'workflowInstancia',
    skipRejectionHandling: true,
    initialState: {
        loading: false,
        errorMessage: null,
        entities: [],
        entity: {},
        updating: false,
        totalItems: 0,
        updateSuccess: false,
    } as EntityState<any>,
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getEntities), (state, action) => {
                const { data, headers } = action.payload;
                return {
                    ...state,
                    loading: false,
                    entities: data,
                    totalItems: parseInt(headers['x-total-count'], 10),
                };
            })
            .addMatcher(isFulfilled(createEntity), (state, action) => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = true;
                state.entity = action.payload.data;
            })
            .addMatcher(isFulfilled(deleteEntity), state => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = true;
            })
            .addMatcher(isPending(getEntities), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.loading = true;
            })
            .addMatcher(isPending(createEntity, deleteEntity), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.updating = true;
            })
            .addMatcher(isRejected(getEntities), (state, action) => {
                state.loading = false;
                state.updateSuccess = false;
                state.errorMessage = extractErrorMessage(action.error, 'Error al cargar los datos');
            })
            .addMatcher(isRejected(createEntity, deleteEntity), (state, action) => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = false;
                state.errorMessage = extractErrorMessage(action.error, 'Error al eliminar el registro');
            });
    },
});

export const { reset } = WorkflowInstanciaSlice.actions;
export default WorkflowInstanciaSlice.reducer;
